<wbo-edit-page #editPage (saved)="saved()" (saving)="onSave($event)"
               [hideClone]="true" [exitRoute]="exitRoute" [title]="model.data.name" [formGroup]="editPage.formGroup">
    <wbo-bi-server-status-indicator *ngIf="serverStatusModel.isInitialising()"></wbo-bi-server-status-indicator>
    <div *ngIf="serverStatusModel.isInitialised()" class="dashboard">
        <div class="dashboard-edit">
            <div class="dashboard-edit-form">
                <fui-rows>
                    <fui-row>
                        <wbo-text-edit-control [(ngModel)]="model.data.name" formControlName="name">
                        </wbo-text-edit-control>
                    </fui-row>
                    <fui-row>
                        <wbo-single-select-edit-control [(ngModel)]="cubeName" formControlName="cubeName"
                                                        [allowClearSelectionOption]="false"
                                                        [readonlyOnEdit]="true"
                                                        (onSelect)="onChangeCubeName()">
                            <wbo-select-options>
                                <wbo-select-option [value]="'ProductSales'"
                                                   label="wbo.bi-dashboard.common.cube.productSales"></wbo-select-option>
                                <wbo-select-option [value]="'KVDDisplay'"
                                                   label="wbo.bi-dashboard.common.cube.kvdDisplay"></wbo-select-option>
                                <wbo-select-option [value]="'KVDItems'"
                                                   label="wbo.bi-dashboard.common.cube.kvdItems"></wbo-select-option>
                            </wbo-select-options>
                        </wbo-single-select-edit-control>
                    </fui-row>
                    <fui-row>
                        <wbo-checkbox-edit-control [(ngModel)]="model.data.public" formControlName="public"
                                                   [readonly]="!canPublish">
                        </wbo-checkbox-edit-control>
                    </fui-row>

                    <fui-row *ngIf="!fullEdit">
                        <fui-inline-warning
                            [title]="'wbo.bi.common.small-screen-edit.info.title'"
                            [message]="'wbo.bi.common.small-screen-edit.info.message'">
                        </fui-inline-warning>
                    </fui-row>
                </fui-rows>
            </div>
            <div class="dashboard-edit-data" *ngIf="fullEdit">
                <div class="dashboard-edit-data-attributes">
                    <div class="dashboard-edit-data-attributes-pane">
                        <wbo-bi-draggable-attributes-list [attributes]="attributes"
                                                          [title]="'wbo.bi-dashboard.edit.field-set.fields'">
                        </wbo-bi-draggable-attributes-list>
                    </div>
                </div>
                <div class="dashboard-edit-data-selections">
                    <div class="dashboard-edit-data-selections-pane">
                        <wbo-bi-selection-container [title]="'wbo.bi-dashboard.edit.field-set.visualisations'">
                            <wbo-bi-chart-options (selected)="updateChartType($event)"
                                                  [type]="selectedChart?.chartType"></wbo-bi-chart-options>

                            <fui-pill-form-context>
                                <div class="vis-control">
                                    <fui-text-control (valueChange)="titleChange($event)"
                                                      [(value)]="selectedTitle"
                                                      [label]="'wbo.bi.search.field.chart-title.label'"
                                                      [placeholder]="'wbo.bi.search.field.chart-title.placeholder'"
                                                      [removable]="false"></fui-text-control>
                                </div>
                                <div class="vis-control">
                                    <wbo-bi-top-bottom-count-single-select-search-control
                                        (valueChange)="topBottomChange($event)"
                                        [(value)]="selectedTopRef"
                                        [label]="'wbo.bi.search.field.top-bottom-count.label'"
                                        [placeholder]="'wbo.bi.search.field.top-bottom-count.placeholder'"
                                        [removable]="false"></wbo-bi-top-bottom-count-single-select-search-control>
                                </div>
                                <div class="vis-control">
                                    <wbo-bi-reference-single-select-search-control (valueChange)="refLineChange($event)"
                                                                                   [(value)]="selectedRefLine"
                                                                                   [label]="'wbo.bi.search.field.reference.label'"
                                                                                   [placeholder]="'wbo.bi.search.field.reference.placeholder'"
                                                                                   [removable]="false"></wbo-bi-reference-single-select-search-control>
                                </div>
                            </fui-pill-form-context>
                        </wbo-bi-selection-container>


                        <wbo-bi-drop-container (onDrop)="selectAttribute($event)"
                                               [dropAreaLabel]="'wbo.bi-dashboard.edit.field-set.drop-field-here'"
                                               [message]="isMandatoryAttributeSelected() ? undefined : mandatoryAttributeFieldMessage"
                                               [dropZones]="['dimension']"
                                               [showDropArea]="!selectedAttribute"
                                               [icon]="'axes'"
                                               [title]="'wbo.bi-dashboard.edit.field-set.chart-field'">
                            <wbo-bi-draggable-member-select (onDrop)="selectAttribute($event)"
                                                            [cubeDefinition]="cubeDefinition"
                                                            *ngIf="selectedAttribute"
                                                            [data]="selectedAttribute"
                                                            (removed)="removeAttribute()"
                                                            [dropZones]="['dimension']"
                                                            [label]="selectedAttributeLabel"
                                                            (selectedFilterMembersChange)="selectFilterMembersOnChart($event)"
                                                            [selectedFilterMembers]="selectedChart.filterMembers"
                                                            [orderable]="false"></wbo-bi-draggable-member-select>
                        </wbo-bi-drop-container>

                        <wbo-bi-drop-container (onDrop)="appendMeasure($event)"
                                               [dropAreaLabel]="'wbo.bi-dashboard.edit.field-set.drop-value-here'"
                                               [dropZones]="['measure']"
                                               [showDropArea]="!selectedMeasures || selectedMeasures.length === 0"
                                               [icon]="'sum'"
                                               [title]="'wbo.bi-dashboard.edit.field-set.chart-values'">
                            <wbo-bi-draggable-member-select (onDrop)="addMeasureAt($event, i)"
                                                            (removed)="removeMeasure(i)"
                                                            [cubeDefinition]="cubeDefinition"
                                                            *ngFor="let m of selectedMeasures; let i = index"
                                                            [data]="m"
                                                            [dropZones]="['measure']"
                                                            [label]="m.value"
                                                            [orderable]="true"></wbo-bi-draggable-member-select>
                        </wbo-bi-drop-container>

                        <wbo-bi-drop-container (onDrop)="addFilterAt($event, selectedFilters.length - 1)"
                                               [dropAreaLabel]="'wbo.bi-dashboard.edit.field-set.drop-filter-fields-here'"
                                               [dropZones]="['dimension']"
                                               [showDropArea]="selectedFilters.length == 0"
                                               [icon]="'axes'"
                                               [message]="isMandatoryAttributeSelected() ? undefined : mandatoryAttributeFilterMessage"
                                               [title]="'wbo.bi-dashboard.edit.field-set.dashboard-filters'">
                            <div class="date-range">
                                <fui-pill-form-context>
                                    <wbo-date-range-single-select-search-control
                                        (valueChange)="dashboardDateRange = $event"
                                        [label]="'wbo.bi.search.field.dateRangeRef.label'"
                                        [placeholder]="'wbo.bi.search.field.dateRangeRef.placeholder'"
                                        [removable]="false"
                                        [cube]="cubeName"
                                        [value]="dashboardDateRange">
                                    </wbo-date-range-single-select-search-control>
                                </fui-pill-form-context>
                            </div>
                            <wbo-bi-draggable-member-select (onDrop)="addFilterAt($event, i)"
                                                            [cubeDefinition]="cubeDefinition"
                                                            (removed)="removeFilter(i)"
                                                            *ngFor="let item of selectedFilters; let i = index"
                                                            [data]="item"
                                                            [dropZones]="['dimension']"
                                                            (removed)="removeDashboardFilterMembersOnChart(item)"
                                                            (selectedFilterMembersChange)="selectDashboardFilterMembersOnChart(item, $event)"
                                                            [selectedFilterMembers]="filterModel.getFilterMembersByDimension(item.id)"
                                                            [orderable]="false"></wbo-bi-draggable-member-select>

                        </wbo-bi-drop-container>

                    </div>
                </div>
            </div>
        </div>

        <div class="dashboard-view">
            <wbo-bi-view-header [restrictions]="(dashboardModel.dashboardFilter$ | async)?.restrictions"
                                (refresh)="refresh()" [showRefresh]="true">
            </wbo-bi-view-header>

            <div class="charts">
                <fui-rows *ngIf="layout">
                    <fui-simple-row *ngFor="let r of layout.rows; trackBy: trackByFn">
                        <fui-column *ngIf="r.columns.length == 1">
                            <div
                                [ngClass]="{'selected-chart': isSelected(r.columns[0]), 'unselected-chart': !isSelected(r.columns[0])}">
                                <wbo-bi-dashboard-chart (added)="addChart(r, r.columns[0])"
                                                        (click)="selectChart(r.columns[0])"
                                                        (onDrop)="selectAttributeOrMeasureOnChart($event, r.columns[0])"
                                                        (removed)="removeChart(r, r.columns[0])"
                                                        [chartDef]="r.columns[0]"
                                                        [cubeName]="cubeDefinition.cubeName"
                                                        [dashboardChartUpdated]="dashboardChatUpdated"
                                                        [height]="getChartHeight(r)"
                                                        [showActions]="true"></wbo-bi-dashboard-chart>
                            </div>
                        </fui-column>
                        <fui-two-columns *ngIf="r.columns.length == 2">
                            <fui-column *ngFor="let c of r.columns; trackBy: trackByFn">
                                <div
                                    [ngClass]="{'selected-chart': isSelected(c), 'unselected-chart': !isSelected(c)}">
                                    <wbo-bi-dashboard-chart (added)="addChart(r, c)" (click)="selectChart(c)"
                                                            (onDrop)="selectAttributeOrMeasureOnChart($event, c)"
                                                            (removed)="removeChart(r, c)"
                                                            [chartDef]="c"
                                                            [cubeName]="cubeDefinition.cubeName"
                                                            [dashboardChartUpdated]="dashboardChatUpdated"
                                                            [height]="getChartHeight(r)"
                                                            [showActions]="true"></wbo-bi-dashboard-chart>
                                </div>
                            </fui-column>
                        </fui-two-columns>
                        <fui-three-columns *ngIf="r.columns.length == 3">
                            <fui-column *ngFor="let c of r.columns; trackBy: trackByFn">
                                <div
                                    [ngClass]="{'selected-chart': isSelected(c), 'unselected-chart': !isSelected(c)}">
                                    <wbo-bi-dashboard-chart (added)="addChart(r, c)" (click)="selectChart(c)"
                                                            (onDrop)="selectAttributeOrMeasureOnChart($event, c)"
                                                            (removed)="removeChart(r, c)"
                                                            [chartDef]="c"
                                                            [cubeName]="cubeDefinition.cubeName"
                                                            [dashboardChartUpdated]="dashboardChatUpdated"
                                                            [height]="getChartHeight(r)"
                                                            [showActions]="true"></wbo-bi-dashboard-chart>
                                </div>
                            </fui-column>
                        </fui-three-columns>
                        <fui-four-columns *ngIf="r.columns.length == 4">
                            <fui-column *ngFor="let c of r.columns; trackBy: trackByFn">
                                <div
                                    [ngClass]="{'selected-chart': isSelected(c), 'unselected-chart': !isSelected(c)}">
                                    <wbo-bi-dashboard-chart (click)="selectChart(c)"
                                                            (onDrop)="selectAttributeOrMeasureOnChart($event, c)"
                                                            (removed)="removeChart(r, c)"
                                                            [chartDef]="c"
                                                            [cubeName]="cubeDefinition.cubeName"
                                                            [dashboardChartUpdated]="dashboardChatUpdated"
                                                            [height]="getChartHeight(r)"
                                                            [showActions]="true"></wbo-bi-dashboard-chart>
                                </div>
                            </fui-column>
                        </fui-four-columns>
                    </fui-simple-row>
                </fui-rows>
            </div>
        </div>
    </div>
</wbo-edit-page>
